import React, { PureComponent } from 'react'
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer } from 'recharts'
import { Props } from 'recharts/types/component/Label'
import styled from 'styled-components'

type ProgressChartParam = {
  value: number
  height?: number
  align?: 'left' | 'right' | 'center'
  unit?: string
  label?: boolean
  minValue: number
  maxValue: number
  barColor: string
  border: boolean
}

function ProgressChart(props: ProgressChartParam) {
  const data = [
    {
      name: 'aa',
      data: props.value + props.minValue,
      blank: props.maxValue - props.minValue - props.value,
    },
  ]

  const renderCustomBarLabel = (propss: {
    payload: any
    x: number
    y: number
    width: number
    height: number
    value: number
  }) => {
    const { x, y, width, height, value } = propss

    return props.label ? (
      props.align === 'right' ? (
        <text
          x={x + width - 10}
          y={y + height / 2}
          fill="#fff"
          textAnchor="end"
          alignmentBaseline="central"
        >
          {props.value}
          {props.unit}
        </text>
      ) : props.align === 'center' ? (
        <text
          x={x + width / 2}
          y={y + height / 2}
          fill="#fff"
          textAnchor="middle"
          alignmentBaseline="central"
        >
          {props.value}
          {props.unit}
        </text>
      ) : (
        <text
          x={x + 10}
          y={y + height / 2}
          z={200}
          fill="#fff"
          textAnchor="start"
          alignmentBaseline="central"
        >
          {props.value}
          {props.unit}
        </text>
      )
    ) : (
      <></>
    )
  }

  return (
    <Wrapper>
      <div className="content c-white">
        <ResponsiveContainer height={props.height || 40} width={'100%'}>
          <BarChart
            layout="vertical"
            data={data}
            margin={{ left: 0, right: 0, top: 0, bottom: 0 }}
            stackOffset="expand"
          >
            <XAxis
              type="number"
              hide={true}
              range={[
                Math.min(0, props.minValue),
                Math.max(100, props.maxValue),
              ]}
            />
            <YAxis
              type="category"
              dataKey="name"
              stroke="#fff"
              fontSize="12"
              hide
            />
            <Bar
              isAnimationActive={false}
              className="bar"
              dataKey="data"
              fill={props.barColor}
              stackId="a"
              //stroke="#ccc"
              label={renderCustomBarLabel}
            />
            <Bar
              isAnimationActive={false}
              className="bar"
              dataKey="blank"
              fill="#eee"
              stackId="a"
              //stroke="#ccc"
              //label={renderCustomBarLabel}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Wrapper>
  )
}
const Wrapper = styled.div`
  .bar {
    border: 1px solid #ccc;
  }
`
export default ProgressChart
